module.exports = __webpack_public_path__ + "img/decorationBackground.1311ded1.png";